import React from 'react'
import styled from 'styled-components'

const Content = styled.div`
	display: table-cell;
	vertical-align: middle;
`;

const Wrapper = styled.div`
	display: table;
	margin-left: auto;
	margin-right: auto;
	height: 100%;
	width: ${props => props.width};
	max-width: ${props => props.maxWidth}
`;

export default class Centerer extends React.Component {
	render() {
		return (
			<Wrapper width={this.props.width} maxWidth={this.props.maxWidth}>
				<Content>
					{this.props.children}
				</Content>
			</Wrapper>
		)
	}
}

